<template>
    <CCard class="mb-0 h-100">
        <CCardHeader>
            <h1 class="text-center">{{ $t('app_access') }}</h1>
        </CCardHeader>
        <CCardBody>
            <CContainer fluid>
                <CRow>
                    <CCol>
                        <CJumbotron class="mt-4 lg-jbt-app_access">
                            <h1 class="display-8">
                                {{ $t('app_key') }} 
                                <InfoBallon
                                    tooltipLink="https://google.com"
                                />
                            </h1>
                            <p class="lead">{{ $t('send_leads_by_integration_with_webserivce,_with_an_APP_key') }}.</p>
                            <CContainer fluid>
                                <CRow>
                                    <CCol sm="10">
                                        <CInput
                                            :value.sync="storeGlobalAppId"
                                            readonly
                                            class="m-0"
                                            data-lg-command-copy
                                        >
                                            <template #append>
                                                <CButton @click="copy()">
                                                    <CIcon class="icon" :content="$options.icons.cilCopy"/>
                                                </CButton>
                                            </template>
                                        </CInput>
                                    </CCol>
                                    <CCol sm="2" class="d-flex align-items-end">
                                        <CLink>
                                            {{ $t('regenerate') }}
                                        </CLink>
                                    </CCol>
                                </CRow>
                            </CContainer>

                        </CJumbotron>
                    </CCol>
                </CRow>
            </CContainer>
        </CCardBody>
    </CCard>
    
    
</template>

<script>

import pageMixin from "~/mixins/page.js";
import { cilCopy } from '@coreui/icons';
import InfoBallon from "£lement/InfoBallon";
import { mapGetters } from "vuex";
export default {
    name: "ApiAccessPage",
    middleware: ['auth', 'page'],
    mixins: [pageMixin],
    icons:{
        cilCopy
    },
    components:{
        InfoBallon
    },
    data(){
        return{
        }
    },
    computed: {
        ...mapGetters({
            storeGlobalAppId: "auth/appId",
        })
    },
    methods:{
        async updateData(){
            await this.$store.dispatch('auth/updateAppId');
            this.updatePageLoading(false);
        },
        copy(){
            let copyText = this.$el.querySelector('[data-lg-command-copy]');
            /* Select the text field */
            copyText.select();
            copyText.setSelectionRange(0, 99999); /* For mobile devices */

            /* Copy the text inside the text field */
            document.execCommand("copy");
        }
    },
    async mounted(){
        this.updateData();
    }

}
</script>

<style lang="scss">
    .lg-jbt{
        background-color: #ffffff;
        & .display-8{
            font-size: 2rem;
        }
        & .lead{
            font-size: 1rem;
        }

    }

    .lg-jbt-app_access{
        @extend .lg-jbt;
        & .form-group{
            width: 70%;
            position: relative;
            & input{
                color: white !important;
                background-color: black !important;
                padding: 1.5rem;
            }

            & .input-group-append{
                position: absolute;
                z-index: 1600;
                right: -2%;
                top: 50%;

                & button{
                    background-color: white;
                    border-radius: 50px !important;
                }
            }

        }
    }

</style>